var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center-chart-0"},[_c('span',{staticClass:"center-header"},[_vm._v("累计总人数：")]),_c('span',{staticClass:"center-count"},[_vm._v(" "+_vm._s(_vm.incdata)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }